import api from "@/api";

export const gets = {
  data: () => ({}),

  computed: {
    /*
    arrayCarga() {
      if (this.carga) {
        let items = this.carga;
        let list = [];
        let result = Object.keys(items).map(function(key) {
          list.push(items[key]);
          return items[key];
        });
        return list;
      }
      return [];
    },*/

    cargasAsignadas() {
      // Contabiliza el número de grupos y horas asignadas
      // Crea un objeto con id del docente como key
      // y sub-elementos nombre, plaza_horas, maximo_horas, grupos, horas
      let obj = {};
      let iddocentes = this.docentesId;
      if (this.carga) {
        let items = this.carga;
        let result = Object.keys(items).map(function(key) {
          if (items[key].docente_id !== null) {
            if (typeof obj[items[key].docente_id] !== "undefined") {
              obj[items[key].docente_id].grupos++;
              obj[items[key].docente_id].horas += parseInt(items[key].horas);
            } else {
              obj[items[key].docente_id] = {
                nombre: iddocentes[items[key].docente_id].nombre,
                plaza_horas: iddocentes[items[key].docente_id].plaza_horas,
                maximo_horas: iddocentes[items[key].docente_id].maximo_horas,
                grupos: 1,
                horas: parseInt(items[key].horas),
                detalles: [],
              };
            }
            obj[items[key].docente_id].detalles.push({
              grupo: items[key].semestre + items[key].letra + "-" + items[key].turno,
              materia: items[key].nombre_materia,
              horas: items[key].horas,
            });
          }
          return items[key];
        });
      }
      if (this.tutorias) {
        let items = this.tutorias;
        let result = Object.keys(items).map(function(key) {
          if (items[key].docente_id !== null) {
            if (typeof obj[items[key].docente_id] !== "undefined") {
              obj[items[key].docente_id].grupos++;
              obj[items[key].docente_id].horas++;
            } else {
              obj[items[key].docente_id] = {
                nombre: iddocentes[items[key].docente_id].nombre,
                plaza_horas: iddocentes[items[key].docente_id].plaza_horas,
                maximo_horas: iddocentes[items[key].docente_id].maximo_horas,
                grupos: 1,
                horas: 1,
                detalles: [],
              };
            }
            obj[items[key].docente_id].detalles.push({
              grupo: items[key].semestre + items[key].letra + "-" + items[key].turno,
              materia: "TUTORÍA",
              horas: 1,
            });
          }
          return items[key];
        });
      }
      return obj;
    },

    docentesId() {
      // Crea un objeto con id del docente como key y sub-elementos nombre, plaza_horas, maximo_horas
      if (this.docentes) {
        let items = this.docentes;
        let obj = {};
        let result = Object.keys(items).map(function(key) {
          obj[items[key].id] = {
            nombre: items[key].apellidos + " " + items[key].nombre,
            nombre_apellidos: items[key].nombre + " " + items[key].apellidos,
            plaza_horas: parseInt(items[key].plaza_horas),
            maximo_horas: parseInt(items[key].maximo_horas_frente_a_grupo),
            email: items[key].email,
          };
          return items[key];
        });
        return obj;
      } else return null;
    },

    itemsDocentes() {
      // Genera relación de docentes para v-select
      if (this.docentes) {
        let items = this.docentes;
        let list = [];
        list.push({ text: "- Sin docente -", value: null });
        let result = Object.keys(items).map(function(key) {
          list.push({
            text: items[key].apellidos + " " + items[key].nombre,
            value: items[key].id,
          });
          return items[key];
        });
        return list;
      } else return null;
    },

    itemsSemestres() {
      if (this.periodo.semestre == 1) {
        return [
          { text: "Primero", value: "1" },
          { text: "Tercero", value: "3" },
          { text: "Quinto", value: "5" },
        ];
      } else {
        return [
          { text: "Segundo", value: "2" },
          { text: "Cuarto", value: "4" },
          { text: "Sexto", value: "6" },
        ];
      }
    },
  },

  methods: {
    async actualiza(data, end_loading = true) {
      this.loading = true;
      if (data.action == "insert" || data.data.id + "." != ".") {
        try {
          const response = await api.send(data);
        } catch (error) {
          console.log(error);
        }
      }
      if (end_loading) this.loading = false;
    },

    docenteBlur() {
      this.snacktime = 6000;
    },

    docenteFocus(docente) {
      if (docente) {
        this.snacktime = -1;
        this.snackbar = true;
        this.docFocus = this.cargasAsignadas[docente];
      } else this.snackbar = false;
    },

    async docenteSeleccionado(carga, periodo, grupo, docente, plan_estudio = null) {
      this.docenteFocus(docente);
      let data_data = {
        id: carga,
        periodo_id: periodo,
        grupo_id: grupo,
        docente_id: docente,
      };
      if (plan_estudio) {
        data_data = {
          ...data_data,
          plan_estudio_id: plan_estudio,
        };
      }
      let data = {
        table: plan_estudio ? "cargas" : "tutorias",
        action: carga ? "patch" : "insert",
        scope: "ind",
        data: {
          ...data_data,
        },
      };
      await this.actualiza(data);
      this.loading = true;
      if (data.action == "delete" || data.action == "insert") {
        this.carga = await this.get("cargas", {
          id: this.periodo.id,
          turno: this.turno,
        });
        this.tutorias = await this.get("tutorias", {
          id: this.periodo.id,
          turno: this.turno,
        });
      }
      this.loading = false;
    },

    async get(table, scope, sort = "") {
      const response = await api.send({
        table: table,
        action: "get",
        scope: scope,
        sort: sort,
      });
      if (response.status == 200) {
        return response.data;
      } else return null;
    },

    async getGrupos(periodo) {
      const response = await api.send({
        table: "grupos",
        action: "get",
        scope: "periodo_id = " + periodo,
        sort: "turno, semestre, letra",
        union: "carrera",
      });
      if (response.status == 200) {
        return response.data;
      } else return null;
    },

    itemsCarga(cargaOtutorias, turno, semestre, grupo) {
      if (cargaOtutorias) {
        let items = cargaOtutorias;
        let list = [];
        let result = Object.keys(items).map(function(key) {
          if (items[key].turno == turno && items[key].semestre == semestre && items[key].letra == grupo) list.push(items[key]);
          return items[key];
        });
        return list;
      }
      return null;
    },
  },
};
